export const HEADER = {
  COMPONENT_WEB: 'sgm-docs-ui',
  APPLICATION_JSON: 'application/json',
};
export const METHOD = {
  POST: 'POST',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
};
